import {createSvgIcon} from '../create-svg-icon';

export const TagIcon = createSvgIcon(
  <path d="M20 10V8h-4V4h-2v4h-4V4H8v4H4v2h4v4H4v2h4v4h2v-4h4v4h2v-4h4v-2h-4v-4h4zm-6 4h-4v-4h4v4z" />
, 'TagOutlined');
